import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AgmCoreModule } from '@agm/core';
import { TooltipsModule } from 'ionic4-tooltips';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { RelativeDatePipe } from '../pipes/relative-date.pipe';
import { SeperatePipe } from '../pipes/seperate.pipe';
import { NgOtpInputModule } from 'ng-otp-input';
import { EsimContactInfoFormComponent } from './esim-contact-info-form/esim-contact-info-form.component';
import { NgModule } from '@angular/core';
import { EsimYourOrderComponent } from './esim-your-order/esim-your-order.component';
import { EsimSuccessOrderComponent } from './esim-success-order/esim-success-order.component';
import { EsimQRCodeComponent } from './esim-qr-code/esim-qr-code.component';
import { EsimActivationCodeForDevicesComponent } from './esim-activation-code-for-devices/esim-activation-code-for-devices.component';
import { EsimActivateCmsComponent } from './esim-activate-cms/esim-activate-cms.component';
import { LayoutsModule } from '../layouts/layouts.module';
import { SwiperModule } from "swiper/angular";
import { PipeModule } from '../pipes/pipe.module';

@NgModule({
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    NgOtpInputModule,
    GooglePlaceModule,
    PipeModule,
    NgIdleKeepaliveModule.forRoot(),
    TooltipsModule.forRoot(),
    AgmCoreModule.forRoot({
      // apiKey: environment.MAP_KEY,
      libraries: ['places', 'visualization', 'drawing', 'geometry', 'places']
    }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LayoutsModule,
    SwiperModule
  ],
  declarations: [
    EsimContactInfoFormComponent,
    EsimYourOrderComponent,
    EsimSuccessOrderComponent,
    EsimQRCodeComponent,
    EsimActivationCodeForDevicesComponent,
    EsimActivateCmsComponent,
    EsimActivateCmsComponent,
  ],
  entryComponents: [
  ],
  exports: [
    EsimContactInfoFormComponent,
    EsimYourOrderComponent,
    EsimSuccessOrderComponent,
    EsimQRCodeComponent,
    EsimActivateCmsComponent
  ],
  
  providers:[
    SeperatePipe,
    RelativeDatePipe
  ]
})
export class EsimModule { }
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.TRANSLATION_URL,'.json');
  // return new TranslateHttpLoader(http);
}

